import React, { Component } from 'react';
import { Row } from 'antd';
import { connect } from 'react-redux';

import { queryTerminationMy } from '@api/incubator/termination';

import DateCondition from '@comm/search/DateConditionSearch';
import { setBackInfo } from '@store/modules/back_info';
import TableSettled from './TableSettled';

class PageManage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: {
        list: [],
        loading: false,
        pagination: {},
      },
    };
  }

  componentWillMount() {
    this.type = '0';
  }

  componentDidMount() {
    this.searchCondition = {};
    const { backInfo } = this.props;
    if (backInfo.path === this.props.location.pathname) {
      if (backInfo.start && backInfo.limit) {
        this.current = backInfo.start;
        this.pagination = {
          limit: backInfo.limit,
          start: backInfo.start,
        };
      }
      backInfo.condition && (this.searchCondition.condition = backInfo.condition);
      backInfo.beginDate && (this.searchCondition.beginDate = backInfo.beginDate);
      backInfo.endDate && (this.searchCondition.endDate = backInfo.endDate);
    }
    this.loadData();
  }

  componentWillUnmount() {
    const params = {
      path: this.props.location.pathname,
      ...this.searchCondition,
      ...this.pagination,
    };
    this.props.dispatch(setBackInfo(params));
  }

  handleTableChange = (pagination, filters, sorter) => {
    this.pagination = {
      limit: pagination.pageSize,
      start: pagination.current,
    };
    this.current = pagination.current;
    this.loadData();
  };

  handleSearch = params => {
    this.searchCondition = {
      ...params,
    };
    this.current = 1;
    this.pagination = {
      start: 1,
    };
    this.loadData();
  };

  getTerminationMy = params => {
    this.setState({ loading: true });
    queryTerminationMy(params).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          dataSource: {
            list: res.data,
            pagination: {
              total: res.totalSize,
              pageSize: 15,
              current: this.current,
            },
          },
        });
      }
      this.setState({ loading: false });
    });
  };

  loadData = () => {
    const params = {
      ...this.searchCondition,
      ...this.pagination,
    };
    this.getTerminationMy(params);
  };

  render() {
    const { loading, dataSource } = this.state;
    const parentProps = {
      loading,
      dataSource,
      onChange: this.handleTableChange,
    };
    return (
      <div>
        <Row>
          <DateCondition onChange={this.handleSearch} {...this.searchCondition} />
        </Row>
        <div id="ant-small-table">
          <TableSettled {...parentProps} {...this.props} />
        </div>
      </div>
    );
  }
}

export default connect(state => ({
  backInfo: state.back_info,
}))(PageManage);



// WEBPACK FOOTER //
// ./src/components/incubator/termination/PageMine.js